import { render, staticRenderFns } from "./allowance.vue?vue&type=template&id=e3b0bfa8&scoped=true&"
import script from "./allowance.vue?vue&type=script&lang=js&"
export * from "./allowance.vue?vue&type=script&lang=js&"
import style0 from "./allowance.vue?vue&type=style&index=0&id=e3b0bfa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b0bfa8",
  null
  
)

export default component.exports